export enum MasterTranslation {
  // Header
  SocialsTitle = 'socials_title',

  // Tracking widget
  TrackingWidget = 'tracking_widget_placeholder',
  AddParcels = 'add_parcels',

  // Remove shipment
  DeleteParcel = 'delete_parcel',
  DeleteConfirmation = 'delete_confirmation',
  Cancel = 'cancel',
  Delete = 'delete',
  Deleting = 'deleting',

  // Parcel list
  LoadMore = 'load_more',
  ResetFilter = 'reset_filter',
  NoParcelsAdded = 'no_parcels_added',
  NoParcelsFound = 'no_parcels_found',
  New = 'new',
  Past = 'past',

  // Parcel card
  LookingParcel = 'looking_parcel',
  ParcelNotFound = 'parcel_not_found',

  // Individual view
  NoInfo = 'no_info',
  CarrierDropdownPlaceholder = 'carrier_dropdown_placeholder',
  IndividualCardTitle = 'individual_card_title',
  IndividualCardSubtitle = 'individual_card_subtitle',
  NoResultsFound = 'no_results_found',
  HandledBy = 'handled_by',
  Website = 'website',

  // Cookie banner
  CookieBanner = 'cookie_banner',
  CookiePolicy = 'cookie_policy',

  // Date time
  Today = 'today',
  Yesterday = 'yesterday',

  // Milestones
  Pending = 'pending',
  Ordered = 'ordered',
  InTransit = 'in_transit',
  OutForDelivery = 'out_for_delivery',
  Delivered = 'delivered',
  ToCollect = 'to_collect',
  Collected = 'collected',
  Returned = 'returned',
  Cancelled = 'cancelled',
  ViewMyParcels = 'view_my_parcels',
  Unsubscribe = 'unsubscribe',

  // PMT Onboarding Popup - Sign up screen
  ContinueWithLinkedIn = 'continue_linkedin',
  ContinueWithGoogle = 'continue_google',
  Or = 'or',
  TrackManually = 'or_email_sync_onboarding_pop_up',
  Continue = 'continue',
  Submitting = 'submitting',
  ExistEmailPromptBox = 'google/linkedin_match',
  EmailFormattingErrorMessage = 'email_address_error',
  SkipPMCNewsletter = 'skip_pmc_newsletter',
  SubscribePMCNewsletter = 'subscribe_button_pmc_newsletter',

  // PMT Onboarding Popup - Email verification screen
  VerificationMainText = 'onboarding_popup_verification_main_text',
  VerificationSubText = 'onboarding_popup_verification_sub_text',

  // PMT Onboarding Popup - Success screen
  SuccessMainText = 'onboarding_popup_success_main_text',
  SuccessSubText = 'onboarding_popup_success_sub_text',

  // Header Banner
  ValidLinkTextDesktop = 'valid_link_text_desktop',
  ValidLinkTextMobile = 'valid_link_text_mobile',
  InvalidLinkTextDesktop = 'invalid_link_text_desktop',
  InvalidLinkTextMobile = 'invalid_link_text_mobile',
  ResendLink = 'resend_link',
  SendingLink = 'sending_link',
  Sending = 'sending',
  LinkSent = 'link_sent',

  // PMT Verification Popup
  BrowserVerificationPopupQuestionMainText = 'browser_verification_popup_question_main_text',
  BrowserVerificationPopupQuestionSubText = 'browser_verification_popup_question_sub_text',
  BrowserVerificationPopupSuccessMainText = 'browser_verification_popup_success_main_text',
  BrowserVerificationPopupSuccessSubText = 'browser_verification_popup_success_sub_text',
  SendLinkToEmail = 'send_link_to_email',

  // Email Sync
  EmailConnectedList = 'email_connected_list',
  DisconnectEmailTitle = 'disconnect_email_title',
  DisconnectEmailDescription = 'disconnect_email_description',
  Disconnect = 'disconnect',
  SyncingBannerMainText = 'syncing_banner_main_text',
  SyncingBannerSubText = 'syncing_banner_sub_text',

  // PMT - Orion 18
  Delivery = 'delivery',
  DeliveryCountdown = 'delivery_countdown',
  DeliveryCountdownOne = 'delivery_countdown_1',
  Order = 'order',
  Qty = 'qty',
  Subtotal = 'subtotal',
  Tax = 'tax',
  ShippingFee = 'shipping_fee',
  Discount = 'discount',
  Total = 'total',
  ShippingMethod = 'shipping_method',
  Tracking = 'tracking',
  ViewLess = 'view_less',
  ViewMore = 'view_more',
  PendingParcel = 'pending_parcel',
  OrderConfirmed = 'order_confirmed',
  ToShip = 'to_ship',
  WaitingTrackingInfo = 'waiting_tracking_info',

  // Delayed Shipment Popup
  DelayedShipmentPopupMainText = 'delayed_shipment_popup_main_text',
  DelayedShipmentPopupSubText = 'delayed_shipment_popup_sub_text',
  DelayedShipmentPopupButton = 'delayed_shipment_popup_button',

  // PMT - Horus 1
  EmailListTitle = 'email_list_title',
  TrackingWidgetConnectGmail = 'tracking_widget_connect_gmail',
  UnableConnectEmailMain = 'alert_unable_to_connect_email_main',
  UnableConnectEmailSub = 'alert_unable_to_connect_email_sub',
  MaxEmailsReachedMain = 'alert_max_email_connected_main',
  MaxEmailsReachedSub = 'alert_max_email_connected_sub',
  EmailAlreadyConnectedMain = 'alert_email_already_connected_main',
  EmailAlreadyConnectedSub = 'alert_email_already_connected_sub',

  // PMT - Dialog box buttons
  Save = 'save',
  Saving = 'saving',
  UnsubscribePopupButton = 'unsubscribe_popup_button',

  // PMT - Horus 4 - Actions
  EditNameAction = 'edit_name_action',
  ShareLinkAction = 'share_link_action',
  ArchiveAction = 'archive_action',
  UnarchiveAction = 'unarchive_action',

  // PMT - Horus 4 - Toast messages
  CopyToastSuccess = 'copy_toast_success',
  ArchiveToastSuccess = 'archive_toast_success',
  UnarchiveToastSuccess = 'unarchive_toast_success',
  EditNameToastFail = 'edit_name_toast_fail',
  ArchiveToastFail = 'archive_toast_fail',
  UnarchiveToastFail = 'unarchive_toast_fail',

  // PMT - Horus 4 - Parcel list
  ParcelCardTrackingIdText = 'parcel_card_tracking_id_text',
  ParcelCardOrderIdText = 'parcel_card_order_id_text',
  ArchiveViewHeader = 'archive_view_header',

  // PMT - Horus 4 - Separator
  RecentlyAddedSeparator = 'recently_added_separator',
  PastSeparator = 'past_separator',
  ArrivingTodaySeparator = 'arriving_today_separator',
  ArrivingTomorrowSeparator = 'arriving_tomorrow_separator',
  ArrivingThisWeekSeparator = 'arriving_this_week_separator',
  ArrivingSoonSeparator = 'arriving_soon_separator',
  PendingDeliveryDateSeparator = 'pending_delivery_date_separator',
  DeliveredSeparator = 'delivered_separator',

  // PMT - Horus 4 - Filters
  AllFilter = 'all_filter',
  PendingFilter = 'pending_filter',
  OrderedFilter = 'ordered_filter',
  InTransitFilter = 'in_transit_filter',
  OutForDeliveryFilter = 'out_for_delivery_filter',
  ToCollectFilter = 'to_collect_filter',
  DeliveredFilter = 'delivered_filter',
  ReturnedFilter = 'returned_filter',
  ArchiveFilter = 'archived_filter',
  CancelledFilter = 'cancelled_filter',

  // PMT - Horus 4 - Sort
  LatestAddedSort = 'latest_added_sort',
  LatestUpdateSort = 'latest_update_sort',
  DeliveryDateSort = 'delivery_date_sort',

  // PMT - Horus 4 - Individual shipment view - No parcel
  ShareLinkNotFoundTitle = 'share_link_not_found_title',
  ShareLinkNotFoundSubtitle = 'share_link_not_found_subtitle',
  ShareLinkNotFoundButton = 'share_link_not_found_button',

  // PMT - Horus 4 - Onboarding Popup
  LimitedAccessPopupMainText = 'limited_access_popup_main_text',
  LimitedAccessPopupSubText = 'limited_access_popup_sub_text',
  LimitedAccessPopupSuccessMainText = 'limited_access_popup_success_main_text',
  LimitedAccessPopupSuccessButton = 'limited_access_popup_success_button',

  // PMT - Horus 4 - Tooltips
  ArchiveTooltip = 'archive_tooltip',

  MerchantSectionHeader = 'merchant_section_header',

  // PMT - Dialog box text
  ShipmentSumGuestUserPopupMainText = 'shipment_sum_guest_user_popup_main_text',

  // PMT - Dialog box buttons
  LoginPopupButton = 'login_popup_button',

  // Account Management
  AccNotLogin = 'acc_not_login',
  AccConnectEmailToLogIn = 'acc_connect_email_to_log_in',
  AccLoggedInAs = 'acc_logged_in_as',
  AccSettingsSection = 'acc_settings_section',
  AccSyncedEmailsTitleLoading = 'acc_synced_emails_title_loading',
  AccSyncedEmailsTitleSucceed = 'acc_synced_emails_title_succeed',
  AccSyncedEmailsTitleEmpty = 'acc_synced_emails_title_empty',
  AccSyncedEmailsSubtitleLoading = 'acc_synced_emails_subtitle_loading',
  AccSyncedEmailsSubtitleSucceed = 'acc_synced_emails_subtitle_succeed',
  AccSyncedEmailsCtaAddEmail = 'acc_synced_emails_cta_add_email',
  AccNotificationsTitle = 'acc_notifications_title',
  AccNotificationsSubtitle = 'acc_notifications_subtitle',
  AccNotificationsSummaryEmailTitle = 'acc_notifications_summary_email_title',
  AccNotificationsSummaryEmailSubtitle = 'acc_notifications_summary_email_subtitle',
  AccNotificationsIndividualEmailTitle = 'acc_notifications_individual_email_title',
  AccNotificationsIndividualEmailSubtitle = 'acc_notifications_individual_email_subtitle',
  AccNotificationsMarketingEmailTitle = 'acc_notifications_marketing_email_title',
  AccNotificationsMarketingEmailSubtitle = 'acc_notifications_marketing_email_subtitle',
  AccDialogParcelSummaryEmailsTitle = 'acc_dialog_parcel_summary_emails_title',
  AccDialogParcelSummaryEmailsDescription = 'acc_dialog_parcel_summary_emails_description',
  AccDialogIndividualParcelEmailsTitle = 'acc_dialog_individual_parcel_emails_title',
  AccDialogIndividualParcelEmailsDescription = 'acc_dialog_individual_parcel_emails_description',
  AccDialogMarketingEmailsTitle = 'acc_dialog_marketing_emails_title',
  AccDialogMarketingEmailsDescription = 'acc_dialog_marketing_emails_description',
  AccJoinUsCta = 'acc_join_us_cta',
  AccDataAndPrivacy = 'acc_data_and_privacy',
  AccPrivacyPolicy = 'acc_privacy_policy',
  AccLogoutCtaUpperCase = 'acc_logout_cta_upper_case',
  AccLogoutCtaCaps = 'acc_logout_cta_caps',
  AccLogoutPopupTitle = 'acc_logout_popup_title',
  AccLogoutPopupSubtitle = 'acc_logout_popup_subtitle',
  AccCancelCta = 'acc_cancel_cta',

  // Delete Account
  AccDeleteAccountTitle = 'acc_delete_account_title',
  AccDeleteAccountSubtitle = 'acc_delete_account_subtitle',
  AccDeleteAccountListStart = 'acc_delete_account_list_start',
  AccDeleteAccountListItem1 = 'acc_delete_account_list_item_1',
  AccDeleteAccountListItem2 = 'acc_delete_account_list_item_2',
  AccDeleteAccountListItem3 = 'acc_delete_account_list_item_3',
  AccDeleteAccountListEnd = 'acc_delete_account_list_end',
  AccDeleteAccountCtaCaps = 'acc_delete_account_cta_caps',
  AccDeleteAccountCtaUpperCase = 'acc_delete_account_cta_upper_case',
  AccDeleteAccountModalTitle = 'acc_delete_account_modal_title',
  AccDeleteAccountModalSubtitle = 'acc_delete_account_modal_subtitle',
  AccDeleteAccountConfirmationCta = 'acc_delete_account_confirmation_cta',
  AccDeleteAccountCancelCta = 'acc_delete_account_cancel_cta',
  AccDeleteAccountSucceed = 'acc_delete_account_succeed',
  AccBackToPreviousPage = 'acc_back_to_previous_page',
  AccBackToHome = 'acc_back_to_home',
  AccDeleteAccountError = 'acc_delete_account_error',

  // Manage Email Subscriptions
  ManageEmailSubscriptionSection = 'manage_email_subscription_section',
  ManageEmailSubscriptionSummaryEmails = 'manage_email_subscription_summary_emails',
  ManageEmailSubscriptionSummaryEmailsSubtitle = 'manage_email_subscription_summary_emails_subtitle',
  ManageEmailSubscriptionIndividualEmails = 'manage_email_subscription_individual_emails',
  ManageEmailSubscriptionIndividualEmailsSubtitle = 'manage_email_subscription_individual_emails_subtitle',
  ManageEmailSubscriptionMarketingEmails = 'manage_email_subscription_marketing_emails',
  ManageEmailSubscriptionMarketingEmailsSubtitle = 'manage_email_subscription_marketing_emails_subtitle',
  ManageEmailSubscriptionCta = 'manage_email_subscription_cta',
  ManageEmailSubscriptionUpdateSucceed = 'manage_email_subscription_update_succeed',
  ManageEmailSubscriptionUpdateError = 'manage_email_subscription_update_error',

  // Manage Email Subscription Expired
  ManageEmailSubscriptionExpiredUrl = 'manage_email_subscription_expired_url',
  ManageEmailSubscriptionClickToUnsubscribe = 'manage_email_subscription_click_to_unsubscribe',
  ManageEmailSubscriptionExpiredUrlGuest = 'manage_email_subscription_expired_url_guest',
  ManageEmailSubscriptionClickToLogin = 'manage_email_subscription_click_to_login',

  // Unsubscribe Dialog
  UnsubscribeDialogParcelSummaryEmailsTitle = 'unsubscribe_dialog_parcel_summary_emails_title',
  UnsubscribeDialogParcelSummaryEmailsDescription = 'unsubscribe_dialog_parcel_summary_emails_description',
  UnsubscribeDialogIndividualParcelEmailsTitle = 'unsubscribe_dialog_individual_parcel_emails_title',
  UnsubscribeDialogIndividualParcelEmailsDescription = 'unsubscribe_dialog_individual_parcel_emails_description',
  UnsubscribeDialogMarketingEmailsTitle = 'unsubscribe_dialog_marketing_emails_title',
  UnsubscribeDialogMarketingEmailsDescription = 'unsubscribe_dialog_marketing_emails_description',
  UnsubscribeDialogUnsubscribeButton = 'unsubscribe_dialog_unsubscribe_button',
  UnsubscribeDialogCancelButton = 'unsubscribe_dialog_cancel_button',

  // Affiliate Section
  AffiliateSectionTitle = 'affiliate_product_title',
  AffiliateSectionDescription = 'affiliate_product_description',
  AffiliateSectionCta = 'affiliate_product_cta',
  AffiliateSectionVerifiedPartner = 'affiliate_verified_badge',

  // Affiliate Product Badges
  AffiliateBadgeLimitedTimeDeal = 'affiliate_product_badge_limited_time_deal',
  AffiliateBadgeCoupon = 'affiliate_product_badge_coupon',
  AffiliateBadgePrime = 'affiliate_product_badge_prime',
  AffiliateBadgeAmazonChoice = 'affiliate_product_badge_amazon_choice',

  // Tracking Widget in SEO Pages
  TrackingWidgetLabel = 'tracking_widget_label',
  TrackingWidgetPlaceholderSeoPages = 'tracking_widget_placeholder_seo_pages',
  TrackingWidgetCtaDesktop = 'tracking_widget_cta_desktop',
  TrackingWidgetCtaMobile = 'tracking_widget_cta_mobile',

  // Hero CTA
  HeroCtaSignedIn = 'hero_cta_signedin',

  // Overview Banner
  DefaultOverviewBannerTitle = 'default_overview_banner_title',

  // Tracking Insights sections
  PartnerLogosTitle = 'partner_logos_title',

  // Leaderboards — `{place}` is the localized country / region name
  TopCarriersTitle = 'top_carriers_title',
  TopCarriersTitleGeneric = 'top_carriers_title_generic',
  TopMerchantsTitle = 'top_merchants_title',
  TopMerchantsTitleGeneric = 'top_merchants_title_generic',
  // Carrier pages rank the merchants shipping with that carrier, with no place in the heading
  TopMerchantsTitleCarrier = 'top_merchants_title_carrier',

  // Carrier information
  CarrierInformationTitle = 'carrier_information_title',
  CarrierInformationOverview = 'carrier_information_overview',
  CarrierInformationHeadquarters = 'carrier_information_headquarters',
  CarrierInformationPhone = 'carrier_information_phone',
  CarrierInformationWebsite = 'carrier_information_website',
  CarrierInformationWebsiteLink = 'carrier_information_website_link',

  // How tracking works — `{carrier}` is the carrier name
  HowTrackingWorksTitle = 'how_tracking_works_title',
  HowTrackingWorksTitleGeneric = 'how_tracking_works_title_generic',

  // Customer reviews
  CustomerReviewsTitle = 'customer_reviews_title',
  CustomerReviewsAuthor = 'customer_reviews_author',
  CustomerReviewsPrevious = 'customer_reviews_previous',
  CustomerReviewsNext = 'customer_reviews_next',
}
